import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "store";

import InfiniteScroll from 'react-infinite-scroll-component';
import "./style.scss";
import { generateUniqueKey } from "utils/helpers";
import ContentMasonry from "Components/social-account/ContentMasonry";
import { fetchCompetitionContentThunk } from "slices/competitionAnalysis/thunk";
const CompetitorsContent = () => {
    const filters = useSelector((state: RootState) => state.competitionAnalysis.content.filters);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));

    const loading = useSelector((state: RootState) => state.competitionAnalysis.content.loading);
    const error = useSelector((state: RootState) => state.competitionAnalysis.content.error);


    const competitionContentData = useSelector((state: RootState) => state.competitionAnalysis.content.filtered_lists?.[filterId!]);
    const posts = competitionContentData?.items ?? [];
    const has_more = competitionContentData?.has_more ?? true;
    const page = competitionContentData?.page ?? 1;

    const [initialLoading, setInitialLoading] = useState(true);


    const dispatch: AppDispatch = useDispatch();


    useEffect(() => {
        if (filters) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchCompetitionContentThunk({ filters })).finally(() => {
                    setInitialLoading(false);
                    setFilterId(generateUniqueKey(filters, ['page']))
                })
            }, 500)
        }
    }, [filters])

    const nextPage = () => {
        if (has_more && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchCompetitionContentThunk({ filters: { ...filters, page: nextPageNumber } }))
        }
    }

    return (
        <div className="mt-4">
            <InfiniteScroll
                dataLength={posts.length + 1}
                next={nextPage}
                className=''
                hasMore={has_more}
                loader={<></>}
            >
                <ContentMasonry posts={posts.map((t) => t.social_post)} isLoading={initialLoading || loading} />
                {
                    !(loading || initialLoading) && error &&
                    <div className="d-flex justify-content-center align-items-center">
                        <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                    </div>
                }
            </InfiniteScroll>
            {
                !(loading || initialLoading) && (posts.length === 0) &&
                <div className="d-flex w-100 justify-content-center align-items-center">
                    <div className="length-zero">
                        <h3>Currently there is no content in your list!</h3>
                    </div>
                </div>
            }
        </div>

    )
}

export default CompetitorsContent
